export default function createParticlesAtElementCenter(element, type, amount) {
    if(element.offsetParent === null){
        return;
    }
    const rect = element.getBoundingClientRect();
    const x    = rect.left + rect.width / 2;
    const y    = rect.top + rect.height / 2 + window.scrollY;
    createParticles(x, y, type, amount);
}

export function createParticles(x, y, type, amount) {
    for (let i = 0; i < amount; i++) {
        createParticle(x, y, type);
    }
}

function createParticle(x, y, type) {

    if (!document.body.animate) {
        return;
    }

    const particle = document.createElement('div');
    particle.classList.add('particle');
    document.body.appendChild(particle);
    let size         = Math.floor(Math.random() * 30 + 8);
    let destinationX = (Math.random() - 0.5) * 300;
    let destinationY = (Math.random() - 0.5) * 300;
    let rotation     = Math.random() * 520;
    let delay        = Math.random() * 200;

    switch (type) {
        case 'percent':
            particle.innerHTML      = '%';
            particle.style.fontSize = `${Math.random() * 24 + 10}px`;
            particle.style.color    = `inherit`;
            size                    = 'auto';
            break;
    }

    particle.style.width  = `${size}px`;
    particle.style.height = `${size}px`;
    const animation       = particle.animate([
        {
            transform: `translate(-50%, -50%) translate(${x}px, ${y}px) rotate(0deg)`,
            opacity: 1
        },
        {
            transform: `translate(-50%, -50%) translate(${x + destinationX}px, ${y + destinationY}px) rotate(${rotation}deg)`,
            opacity: 0
        }
    ], {
        duration: Math.random() * 1000 + 5000,
        easing: 'cubic-bezier(0, .9, .57, 1)',
        delay: delay
    });
    animation.onfinish    = removeParticle;
}

function removeParticle(e) {
    e.srcElement.effect.target.remove();
    console.log('Particle removed');
}